<cfp-button
  class="d-print-none"
  [buttonStyle]="buttonStyle()"
  [buttonOutline]="buttonOutline()"
  [dataAnalytics]="dataAnalytics()"
  [disabled]="isLoading()"
  (clicked)="downloadReport()"
>
  <cfp-icon [icon]="'file-pdf'" [classes]="'me-2'" /><ng-content />
</cfp-button>
